module.exports = __webpack_public_path__ + "img/ha.7ff8b9ef.svg";